import { render, staticRenderFns } from "./SidebarChat.vue?vue&type=template&id=26f06ce3&"
import script from "./SidebarChat.vue?vue&type=script&lang=js&"
export * from "./SidebarChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports